import WebApp from '@twa-dev/sdk';
import { type AxiosError } from 'axios';

import { useUserStateRaw } from '@/entities/user/model/user.store';

import { useAppStateRaw } from '@/shared/store/app-store/app-store';

import { api } from '../api';
import { getUser } from '../user/user.api';

export const handleProfileError = async (error: AxiosError) => {
  if (error.config?.url?.includes('v1/user/profile') && error.response?.status === 500) {
    try {
      const { initData } = WebApp ?? {};
      const encodedInitData = encodeURIComponent(initData);

      // Получаем гостевой токен
      const guestTokenResponse = await api.post(
        `/v1/oauth/guest?isTest=${import.meta.env.DEV}&initData=${encodedInitData}`
      );

      // Обновляем токен
      const token = guestTokenResponse.data.token;
      const bearerToken = `Bearer ${token}`;
      api.defaults.headers.common['Authorization'] = bearerToken;
      useAppStateRaw.getState().actions.hydrate({ token });

      // Получаем и обновляем пользователя
      const guestUser = await getUser();
      useUserStateRaw.getState().actions.hydrate({ user: guestUser });

      return { data: guestUser };
    } catch (guestErr) {
      console.error('ERROR in guest auth', guestErr);
    }
  }
  return Promise.reject(error);
};
